import { getCookie } from 'cookies-next';
import cookiesConstants from '@/constants/cookies.constants';
export default function getWindowWidthCookie() {
  const windowWidthCookie = getCookie(
    cookiesConstants.COOKIES.WINDOW_WIDTH.name
  );
  const windowWidthCookieNumber = Number(windowWidthCookie);
  if (
    windowWidthCookie &&
    !isNaN(windowWidthCookieNumber) &&
    windowWidthCookieNumber !== null &&
    windowWidthCookieNumber !== undefined &&
    windowWidthCookieNumber > 0
  ) {
    return windowWidthCookieNumber;
  } else {
    return 0;
  }
}
